/**
 * CommentReply
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';
import User from '../../User';
import GameInfo from '../../GameInfo';
import CommentTextCount from './CommentTextCount';

class CommentReply {

	public onReply: any;

	public onUploadBefore: any;

	public onSubmit: any;

	private $parent: any;

	private articleId: string;

	private _id: string;

	private id: string;

	private commentId: string;

	private removeCommentId: string;

	private $write: any;

	private isSubmit: boolean;

	private lastData: any;

	private formId: string;

	private commentTextCount: CommentTextCount;

	private textArea: string;

	private currTarget: any;

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.id = 'contentReply';
		this.articleId = articleId || Util.getParams().articleId;
		this.commentId = '';
		this.removeCommentId = '';
		this.isSubmit = false;
		this.lastData = {
			contents: '',
		};

		this.onReply = new Util.Observer();
		this.onUploadBefore = new Util.Observer();
		this.onSubmit = new Util.Observer();
		this.onSubmit.add( ( data: any ) => {
			this.result( data );
		});

		this.addSelector();

		this.formId = `comment-form-${this.id}`;
		this.commentTextCount = new CommentTextCount( `#${this._id} .${this.formId}` );
	}

	public getNode() {
		return jQuery( this.textArea );
	}

	public appBanned() {
		const url = Config.app.banned( Util.net( '.' ) );
		const _post = Util.get( url, 'GET' );
		const _post$ = Util.from( _post );
		_post$.subscribe( ( data: any ) => {
			if ( data.is_banned === true ) {
				Config.alert( Config.L10N.alert_banned );
				return;
			}

			this.formCheckAndSubmit();

		}, ( err: any ) => {
			Config.alert( err.message );
		});
	}

	public appLevelBanned() {
		const _lv = Util.getParams().level;
		if ( _lv && _lv < 9 ) {
			Config.alert( Config.L10N.alert_level_check );
			jQuery( this.textArea ).blur();
			return true;
		}
		return false;
	}

	public setUI() {
        const win = window as any;
        this.$write = ( !Config.isLogin() ) ?
			jQuery( Template.commentWrite( this.id, Config.L10N.comment_reply_placeholder_logout ) ) :
			jQuery( Template.commentWrite( this.id, ( Config.isCommentUpload && Config.isCommentEmoticon ) ?
				Config.L10N.comment_reply_placeholder_image :
				Config.L10N.comment_reply_placeholder_login ) );

        jQuery( 'body' ).on( 'focus', this.textArea , ( evt ) => {
			if ( !Config.isLogin() ) {
				jQuery( this.textArea ).blur();

				if ( win.GNBLogin ) {
                    win.GNBLogin();
                } else {
                    Config.alert( Config.L10N.alert_login );
                }
				return;
			}

			if ( User.isCheckNotExistGameAccount() && GameInfo.isLogined() ) {
				Config.alert( Config.L10N.alert_not_exist_gameaccount );
				jQuery( this.textArea ).blur();
				return;
			}

			if ( Config.isBnsApp && this.appLevelBanned() ) {
				// 10lv
				return;
			}

			// hover
			jQuery( `#${this._id} .comment-form-${this.id}` ).addClass( 'is-focus' );
		});

        jQuery( 'body' ).on( 'click' , ( evt ) => {
			const $thisForm = jQuery( `#${this._id} .comment-form-${this.id}` );

			if (!$thisForm.is( evt.target ) && $thisForm.has( evt.target ).length === 0 ) {
				$thisForm.removeClass( 'is-focus' );
			}
		});

        jQuery( 'body' ).on( 'click', `#${this._id} .btn-${this.id}`, ( evt ) => {
			evt.preventDefault();

			if ( Config.isBnsApp ) {
				this.appBanned();
			} else {
				this.formCheckAndSubmit();
			}
		});

        // reply comment Event
        jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .co-btn-comments`, ( evt ) => {
			const _$this: any = jQuery( evt.currentTarget );
			this.currTarget = _$this.parent().parent();

			if ( this.currTarget.has( this.$write ).length && this.$write.is( ':visible' ) ) {
				this.$write.hide();
			} else {
				this.commentId = _$this.attr( 'data-commentid' );
				this.currTarget.append( this.$write.show() );
				this.$write.find( 'textarea' ).val( '' );
				this.commentTextCount.reset();

				jQuery( 'iframe.comment-framecontentReply' ).off().on( 'load', ( loadEvt ) => {
					loadEvt.preventDefault();
					const $this = jQuery( loadEvt.target );

					$this.contents().off().on( 'click', ( clickEvt ) => {
						const commentId = $this.parents( 'div.comment-article' ).attr( 'data-commentid' );
						this.onUploadBefore.emit( commentId );
					});
				});
			}
		});

        // return jquery Node
        return this.$write;
	}

	public submit( _data: any, type: string ) {

		if ( this.isSubmit ) {
			return;
		}

		this.isSubmit = true;
		this.lastData = _data;
		const _method = 'POST';

		// if( Config.isBnsApp ) _method = 'PUT';

		// developer Emoticon
		const commentAPI = Config.commentWrite({
			board: Config.board,
			articleId: this.articleId});
		const win = window as any;
		if ( win._commentInfo && win._commentInfo.emoticonUrl && win._commentInfo.isOperator ) {
			this.lastData.emoticonUrl = win._commentInfo.emoticonUrl;
		}

		const _post = Util.get( commentAPI, _method, this.lastData );
		const _post$ = Util.from( _post );
		_post$.subscribe( ( data: any ) => {
			data = Util.convertCamelCase( data );

			if ( type ) {
				data.commentResourceType = type;
			}

			this.onSubmit.emit( data );
			setTimeout( () => {
				this.isSubmit = false;
			});
		}, ( data: any ) => {

			data = Util.convertCamelCase( data );

			setTimeout( () => {
				this.isSubmit = false;
			});

			Config.apiError( data );
		});
	}

	public setCommentId( commentId: string ) {
		this.commentId = commentId;
	}

	public formCheckAndSubmit() {
		const _$this: any = jQuery( this.textArea );
		let _val = _$this.val();

		_val = Util.escapeTag( _val );

		if ( _val.length === 0 || !jQuery.trim( _val ) ) {
			Config.alert( Config.L10N.alert_empty_reply );
			return;
		}

		if ( _val.length > Config.commentTextMaxCount ) {
			Config.alert( Config.L10N.comment_placeholder_login );
			return;
		}

		_val = _val.replace(/\n/g, '<br />');

		const _data = {
			contents: _val,
			commentId: this.commentId,
		};

		// if( Config.isBnsApp ){
		// 	_data.c = this.commentId;
		// 	_data.articleId = this.articleId;
		// 	_data.boardName = Util.getParams().boardAlias;
		// }

		this.submit( _data, '' );
	}

	private result( data: any ) {

		const _$this = jQuery( this.textArea );

		if ( data.comment_id ) {
			data.number = data.comment_id;
		}

		// If data.number is not present, Page should be reloaded;
		if ( !data.number ) {
			location.reload();
		}

		if ( data.number || data.result === 'success' ) {
			const win = window as any;
			const _userData = win.userData;
			const _profileImage = _userData && _userData.gameAccount && _userData.gameAccount.profileImage;
			const subData = _userData && _userData.gameAccount && _userData.gameAccount.subData;
			let racename = '';

			if ( subData && subData[ 2 ] && subData[ 2 ].title === 'race' ) {
				racename = subData[ 2 ].value;
			}

			const item: any = {
				commentList: [{
					isNewWrited: true,
					depth: 1,
					commentId: data.number || '',
					postDate: data.generatedDate || new Date(),
					updateDate: data.generatedDate || new Date(),
					contents: this.lastData.contents || '',
					goodCount: 0,
					replyCount: 0,
					writer: {
						loginUser: {
							uid: Config.guid || '',
							name: Config.nickName || '',
						},
						gameUser: {
							gameServerId: Config.serverId || '',
							gameCharacterName: Config.gameName || '',
							gameUserUid: Config.gameUserUid || '',
							profileImage: _profileImage || '',
						},
					},
					reserved1: {
						contents: {
                            profileImageUrl: _profileImage || '',
							raceName: racename,
						},
					},
				}],
			};

			if ( win._commentInfo && win._commentInfo.emoticonUrl && win._commentInfo.isOperator ) {
				item.commentList[ 0 ].writer.emoticonUrl = win._commentInfo.emoticonUrl;
			}

			const _comment = Template.commentList( item, Config.L10N.a_few_seconds_ago );
			const _$article = jQuery( `#${this._id} .comment-article[data-commentid=${this.commentId}]` );
			const _$articleComments = _$article.nextAll( '.comment-article:first, .comment-article-delete:first' ).first();

			( _$articleComments.length ) ?
				_$articleComments.before( _comment ) :
				_$article.after( _comment );

			const commentCount = _$article.find( '.co-btn-comments .text' );
			commentCount.text( parseInt( commentCount.text() || '0', 10 ) + 1 );

			if ( data.commentResourceType !== 'emoticon' && data.commentResourceType !== 'image' ) {
				_$this.val( '' );
				this.commentTextCount.reset();
			}

			this.onReply.emit();
		}
	}

	private addSelector() {
		this.textArea = `#${this._id} .${this.id}`;
	}

	private enterSubmit() {
		jQuery( 'body' ).on( 'keypress', `#${this._id} .${this.id}` , ( evt ) => {
			const key = evt.keyCode;
			if ( key === 13 ) {
				evt.preventDefault();
				this.formCheckAndSubmit();
			}
		});
	}
}

export default CommentReply;
